<div id="cookiesDialog">
	<p-dialog
		[header]="'Cookies 使用說明'"
		[(visible)]="isShow"
		[style]="{ width: '90%', 'max-width': '500px' }"
		[modal]="true"
		[dismissableMask]="false"
		[draggable]="false"
		[showHeader]="true"
	>
		<ng-template pTemplate="content">
			<p style="font-weight: 300">
				我們使用 cookies 以增強您的瀏覽體驗並分析我們的流量，點擊「全部接受」即表示您同意我們使用
				cookies。在我們的 cookie 政策中了解更多。
			</p>

			<div class="d-flex justify-content-center align-items-center mt-4">
				<div class="bg-danger">
					<button type="button" class="btn btn-refuse mr-2" (click)="onSubmitContact()">拒絕</button>
					<button type="button" class="btn btn-accept" (click)="onSubmitContact()">全部接受</button>
				</div>
			</div>
		</ng-template>
	</p-dialog>
</div>
